import { updateUrlParam } from '../../util/url'

export const setSelectedProductId = (state, payload) => {
  state.selectedProductOpen = !!payload
  state.selectedProductId = payload

  updateUrlParam('product', state.selectedProductId, undefined, false)
}
